<div class="reports-home-wrapper">
  <div class="dashboard">
    <div class="card half-height">
      <div class="card-header">
        <h3>REPORTS</h3>
      </div>
      <hr/>
      <p>
        Welcome to the Reports page! This tool allows you to generate and view various reports based on the data collected in the system. You can filter reports by date, type, and other criteria to get the insights you need. Use the available options to view your reports.
      </p>
    </div>
  </div>
</div>


